import { render, staticRenderFns } from "./TagsMultiselect.vue?vue&type=template&id=f31f7864&scoped=true"
import script from "./TagsMultiselect.vue?vue&type=script&lang=js"
export * from "./TagsMultiselect.vue?vue&type=script&lang=js"
import style0 from "./TagsMultiselect.vue?vue&type=style&index=0&id=f31f7864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31f7864",
  null
  
)

export default component.exports